import React, { useState, useEffect, useContext } from 'react';

import { Link } from 'gatsby';

import { I18nContext, useIntl } from '../../../plugins/publicis-gatsby-plugin-i18n';
import { IconDeploySelector } from '../../Atoms/Icons/Icons';
import { uniqueID } from '../../Utils/Utils'

import './Languages.scss';

let classNames = require('classnames');

const Languages = () => {
  const [pathname, setPathname] = useState();
  const [showList, setShowList] = useState(false);

  const i18n = useContext(I18nContext);
  const intl = useIntl();

  useEffect(() => {
    setPathname(window.location.pathname);
  }, []);

  const onKeyDownShowList = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      toogleShowList();
    }
    if (showList && e.keyCode === 9) {
      toogleShowList('true')
    }
  }
  const onClickShowList = (e) => {
    e.preventDefault();
    if (e.which && window.innerWidth < 1024) {
      toogleShowList();
    }
  }

  const toogleShowList = (showValue) => {
    if (showValue) {
      setShowList(showValue === 'true' ? true : false);
    } else {
      setShowList(!showList);
    }
  }

  const onKeyDownListItem = (e, isLast) => {
    if (e.keyCode === 9 && isLast) {
      toogleShowList('false');
    }
  }

  const uniqueID_Exp_Bouton = uniqueID('exp_button_lang')
  const uniqueID_listbox_lang = uniqueID('listbox_lang');

  return (
    <div className="languages_component" tabIndex="-1" onMouseEnter={() => toogleShowList('true')} onMouseLeave={() => toogleShowList('false')}>
      <button className="current_nav"
        tabIndex="0"
        onKeyDown={onKeyDownShowList}
        onClick={onClickShowList}
        aria-haspopup="listbox"
        aria-labelledby={`exp_elem_lang ${uniqueID_Exp_Bouton}`}
        aria-expanded={showList ? "true" : "false"}
        id={uniqueID_Exp_Bouton}
        aria-controls={uniqueID_listbox_lang}
        role="combobox"
        aria-label={`${intl.formatMessage({ id: `ariaLabel.language_selector` })} - ${intl.formatMessage({ id: `ariaLabel.language_${i18n.language}` })} (${intl.formatMessage({ id: `ariaLabel.current_language` })})`}

      // aria-label={intl.formatMessage({ id: 'ariaLabel.choose_website_language' })}
      //aria-activedescendant={showList ? "combo1-0" : ""}
      >
        {i18n.language.toUpperCase()}
        <IconDeploySelector aria-hidden="true" />
      </button>
      <ul className={classNames('select_lang', { 'show': showList })} role="listbox" aria-labelledby="exp_elem_lang" id={uniqueID_listbox_lang} tabIndex="-1">
        {i18n.paths.map(({ label, link }, i) => (
          <li style={{ display: label.toLowerCase() === 'de' ? 'none' : '' }} role="option" id={uniqueID('dropdown_lang_')} key={i} onKeyDown={(e) => onKeyDownListItem(e, i18n.paths.length - 1 === i)}>
            <Link
              className={pathname === link ? 'active' : ''}
              to={link}
              aria-label={intl.formatMessage({ id: `ariaLabel.language_${label}` })}
              lang={label}
            >
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Languages;
